(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["combo-dd-cali-description"] && !window.DesignMode) return;
  try {
    
$('.desc-btn form label:first').addClass('checked');
$('.desc-btn form label input').click(function(){
  $('.desc-btn form label').removeClass('checked');
  $(this).parent('label').addClass('checked');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["combo-detail-section"]) return;
  try {
    
$('.detail-btn form label:first').addClass('checked');
$('.detail-btn form label input').click(function(){
  $('.detail-btn form label').removeClass('checked');
  $(this).parent('label').addClass('checked');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-logo-slider"] && !window.DesignMode) return;
  try {
    
  $('.featured-logo-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 300,
  centerMode: true,
  centerPadding: '100px',
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  variableWidth: true,
  autoplaySpeed: 0,
  speed: 6000,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifely-create-coln-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper('.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      300: { 
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      640: { 
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-new-old"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items-new"] && !window.DesignMode) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-brand-logo-slider"] && !window.DesignMode) return;
  try {
    
$('#brand-logo-slider').slick({
  slidesToShow: 2,  
  slidesToScroll: 1,
  autoplay: true,
  centerMode: true, 
  autoplaySpeed: 0,
  speed: 8000,
  pauseOnHover: false,
  arrows: false,
  cssEase: 'linear',
  mobileFirst:true,
  responsive: [
      {
        breakpoint: 1024,
        settings: {
            slidesToShow: 9 
        }
      },
      {
        breakpoint: 767,
        settings: {
            slidesToShow: 4 
        }
      },
      {
        breakpoint: 320,
        settings: {
            slidesToShow: 2
        }
      }
  ]
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
